module.exports = __webpack_public_path__ + "img/tu_file_other.65cb9ba4.svg";